import {
  createTwoStepPaymentForm,
  createTwoStepPaymentFormStepOptIn,
  createTwoStepPaymentFormStepPayment,
} from 'client/components/core/Sidebar/components/Settings/entities/two-step-payment-form-settings/utils/create-two-step-payment-form'
import structureTypes from 'common/constants/structureTypes'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { TwoStepPaymentFormInterface } from 'common/types/entities/two-step-payment-form-interface'
import {
  migrateBackgroundColor,
  migrateFullBorderType,
  migrateMargin,
  migratePadding,
  migrateReadOnly,
} from 'tools/commands/migrate/utils/migrateUtils'

export const migrateFullTwoStepPaymentForm = (entity: OldEntityInterface) => {
  switch (entity.type) {
    case structureTypes.TWO_STEP_PAYMENT_FORM:
      return migrateTwoStepPaymentForm
    case structureTypes.TWO_STEP_PAYMENT_FORM_STEP_OPT_IN:
      return migrateTwoStepPaymentFormOptInStep
    case structureTypes.TWO_STEP_PAYMENT_FORM_STEP_PAYMENT:
      return migrateTwoStepPaymentFormPaymentStep
    default:
      return (invalidEntity: OldEntityInterface) => {
        console.error(
          'incorrect entity passed to migrateTwoStepPaymentFormEntities',
        )
        return invalidEntity
      }
  }
}

export const migrateTwoStepPaymentForm = (
  entity: OldEntityInterface,
): TwoStepPaymentFormInterface => {
  const twoStepPaymentForm = createTwoStepPaymentForm(
    entity.parentId,
    entity.masterBlockId,
  )

  if (entity.isMasterBlockRoot) {
    twoStepPaymentForm.isMasterBlockRoot = entity.isMasterBlockRoot
  }
  if (entity.masterBlockId) {
    twoStepPaymentForm.masterBlockId = entity.masterBlockId
  }

  twoStepPaymentForm.id = entity.id
  twoStepPaymentForm.childIds = entity.childIds as string[]

  if (entity.options.appearance) {
    twoStepPaymentForm.appearance.desktop = entity.options.appearance.desktop
    twoStepPaymentForm.appearance.mobile = entity.options.appearance.mobile
  }

  if (entity.styles.padding) {
    twoStepPaymentForm.padding = migratePadding(entity.styles.padding)
  }
  if (entity.mobileStyles.padding) {
    twoStepPaymentForm.mobilePadding = migratePadding(
      entity.mobileStyles.padding,
    )
  }

  if (entity.options.headerTextColor) {
    twoStepPaymentForm.headerTextColor = entity.options.headerTextColor
  }
  if (entity.mobileOptions.headerTextColor) {
    twoStepPaymentForm.mobileHeaderTextColor =
      entity.mobileOptions.headerTextColor
  }

  if (entity.options.headerUnderlineColor) {
    twoStepPaymentForm.headerUnderlineColor =
      entity.options.headerUnderlineColor
  }
  if (entity.mobileOptions.headerUnderlineColor) {
    twoStepPaymentForm.mobileHeaderUnderlineColor =
      entity.mobileOptions.headerUnderlineColor
  }

  if (entity.options.buttonBackgroundColor) {
    twoStepPaymentForm.buttonBackgroundColor =
      entity.options.buttonBackgroundColor
  }
  if (entity.mobileOptions.buttonBackgroundColor) {
    twoStepPaymentForm.mobileButtonBackgroundColor =
      entity.mobileOptions.buttonBackgroundColor
  }

  if (entity.options.buttonTextColor) {
    twoStepPaymentForm.buttonTextColor = entity.options.buttonTextColor
  }
  if (entity.mobileOptions.buttonTextColor) {
    twoStepPaymentForm.mobileButtonTextColor =
      entity.mobileOptions.buttonTextColor
  }

  if (entity.options.headerBackgroundColor) {
    twoStepPaymentForm.headerBackgroundColor =
      entity.options.headerBackgroundColor
  }
  if (entity.mobileOptions.headerBackgroundColor) {
    twoStepPaymentForm.mobileHeaderBackgroundColor =
      entity.mobileOptions.headerBackgroundColor
  }

  twoStepPaymentForm.htmlAttrId = entity.options.attrId

  migrateMargin(twoStepPaymentForm, entity)
  migrateFullBorderType(twoStepPaymentForm, entity)
  migrateBackgroundColor(twoStepPaymentForm, entity)
  migrateReadOnly(twoStepPaymentForm, entity)

  return twoStepPaymentForm
}

// structureTypes.TWO_STEP_PAYMENT_FORM_STEP_OPT_IN
export const migrateTwoStepPaymentFormOptInStep = (
  entity: OldEntityInterface,
) => {
  const twoStepPaymentFormOptInStep = createTwoStepPaymentFormStepOptIn({
    parentId: entity.parentId,
  })

  twoStepPaymentFormOptInStep.masterBlockId = entity.masterBlockId
  twoStepPaymentFormOptInStep.headline = entity.options.headline
  twoStepPaymentFormOptInStep.subHeadline = entity.options.subHeadline
  twoStepPaymentFormOptInStep.buttonText = entity.options.buttonText
  twoStepPaymentFormOptInStep.buttonSubText = entity.options.buttonSubText
  twoStepPaymentFormOptInStep.footerText = entity.options.footerText
  twoStepPaymentFormOptInStep.id = entity.id
  twoStepPaymentFormOptInStep.childIds = entity.childIds || []
  twoStepPaymentFormOptInStep.htmlAttrId = entity.options.attrId

  migrateMargin(twoStepPaymentFormOptInStep, entity)

  return twoStepPaymentFormOptInStep
}

// structureTypes.TWO_STEP_PAYMENT_FORM_STEP_PAYMENT
export const migrateTwoStepPaymentFormPaymentStep = (
  entity: OldEntityInterface,
) => {
  const twoStepPaymentFormPaymentStep = createTwoStepPaymentFormStepPayment({
    parentId: entity.parentId,
  })

  twoStepPaymentFormPaymentStep.masterBlockId = entity.masterBlockId
  twoStepPaymentFormPaymentStep.headline = entity.options.headline
  twoStepPaymentFormPaymentStep.subHeadline = entity.options.subHeadline
  twoStepPaymentFormPaymentStep.buttonText = entity.options.buttonText
  twoStepPaymentFormPaymentStep.buttonSubText = entity.options.buttonSubText
  twoStepPaymentFormPaymentStep.footerText = entity.options.footerText
  twoStepPaymentFormPaymentStep.id = entity.id
  twoStepPaymentFormPaymentStep.childIds = entity.childIds as string[]
  twoStepPaymentFormPaymentStep.htmlAttrId = entity.options.attrId

  migrateMargin(twoStepPaymentFormPaymentStep, entity)

  return twoStepPaymentFormPaymentStep
}
